import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import type { IconProps } from '../../primitives/types.js';

/** Play — two offset ripple rings + soft triangle pulse.
 *  Ripples pair on opposite phases so at least one is always visible,
 *  creating the feel of a continuously-emitting speaker/transmission. */
export function IcnPlay(props: IconProps): ReactNode {
  const reduced = useReducedMotion();
  return (
    <Svg {...props} iconName="play">
      {!reduced && (
        <>
          <circle cx="8" cy="8" r="4.5" opacity="0.5" fill="none" stroke="currentColor">
            <animate
              attributeName="r"
              values="4.5;8"
              keyTimes="0;1"
              dur="2s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              values="0.5;0"
              keyTimes="0;1"
              dur="2s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="8" cy="8" r="4.5" opacity="0" fill="none" stroke="currentColor">
            <animate
              attributeName="r"
              values="4.5;8"
              keyTimes="0;1"
              dur="2s"
              begin="1s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              values="0.5;0"
              keyTimes="0;1"
              dur="2s"
              begin="1s"
              repeatCount="indefinite"
            />
          </circle>
        </>
      )}
      <path d="M5 3.5v9L13 8l-8-4.5z" fill="currentColor">
        {!reduced && (
          <animateTransform
            attributeName="transform"
            type="scale"
            values="1;1.05;1"
            dur="2s"
            repeatCount="indefinite"
            additive="sum"
          />
        )}
      </path>
    </Svg>
  );
}
